<template>
  <div>
    <Navbar />
    <div class="columns">
      <SideBar class="menu-sidebar" />
      <section class="qi-content">
        <header>
          <h1>Agenda</h1>
          <div v-if="searchAtt" style="margin-top: -11.5px">
            <vs-col vs-w="9" vs-sm="6">
              <vs-input
                v-model="attendanceId"
                label="Código do Atendimento: *"
                type="number"
              />
            </vs-col>
            <vs-col vs-w="3" vs-sm="6">
              <vs-button
                style="width: 100%; margin-top: 15px"
                icon="search"
                :disabled="!attendanceId"
                @click="attendanceSearch(attendanceId)"
              >
                Buscar Atendimento
              </vs-button>
            </vs-col>
            <div
              v-show="msgAttendance"
              style="width: 100% !important"
              vs-justify="center"
            >
              <vs-col>
                <vs-alert
                  color="#1F74FF"
                  closable
                  :active.sync="msgAttendance"
                  close-icon="close"
                >
                  {{ msgAttendance }}
                </vs-alert>
              </vs-col>
            </div>
            <vs-divider />
          </div>
          <p style="font-size: 0.7em">
            * Clique no número do atendimento para visualizar e/ou atualizar a
            discussão e os parâmetros do atendimento.<br />
            ** Clique no nome do cliente para visualizar os dados de contato
          </p>
        </header>
        <vs-row>
          <NewSale />
        </vs-row>
        <vs-table
          v-if="diary"
          class="pd-table"
          :max-items="descriptionItems[0]"
          pagination
          :data="diary"
          description
          :description-items="descriptionItems"
          description-title="Registros"
          description-connector="de"
          description-body="Mostrar"
          search
        >
          <template slot="thead">
            <th>Simular</th>
            <th @click="sortData('CODATENDIMENTO')">Atendimento</th>
            <th @click="sortData('ABERTURA')">Criação</th>
            <th @click="sortData('CLIENTE')">Cliente</th>
            <th @click="sortData('TAREFA')">Etapa/Fila</th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr
              :data="tr"
              class="pointer"
              :key="indextr"
              v-for="(tr, indextr) in data"
            >
              <vs-td>
                <vs-button
                  @click="startSimulation(data[indextr])"
                  color="primary"
                  type="filled"
                  icon="arrow_forward"
                />
              </vs-td>
              <vs-td>
                <div class="b__important">
                  <a href="#" @click="showDiscussionScreen(data[indextr])">
                    {{ data[indextr].CODATENDIMENTO }}
                  </a>
                </div>
                <div class="b__small b__bt">
                  {{ data[indextr].TIPOATENDIMENTO }}
                </div>
              </vs-td>
              <vs-td>
                <div class="b__important">
                  {{ data[indextr].ABERTURA | moment }}
                </div>
              </vs-td>
              <vs-td>
                <div class="b__important">
                  <a href="#" @click="showContact(data[indextr])">
                    {{ data[indextr].CLIENTE }}</a
                  >
                </div>
              </vs-td>

              <vs-td>
                <div class="b__important">{{ data[indextr].TAREFA }}</div>
                <div class="b__small">{{ data[indextr].ATENDENTE }}</div>
              </vs-td>
              <vs-popup :title="client" :active.sync="contactScreen">
                <vs-row>
                  <vs-col>
                    <div style="display: flex">
                      <span
                        style="
                          margin-top: 7.15px;
                          color: #9b0e1c;
                          margin-right: -2.5px;
                          font-size: 20px;
                        "
                        class="material-icons"
                      >
                        headset_mic
                      </span>
                      <p>
                        Telefone:
                        <strong>
                          {{ telephone }}
                        </strong>
                      </p>
                    </div>
                    <div style="display: flex">
                      <span
                        style="
                          margin-top: 7.15px;
                          color: #9b0e1c;
                          margin-right: -2.5px;
                          font-size: 20px;
                        "
                        class="material-icons"
                      >
                        email
                      </span>
                      <p>
                        E-mail:
                        <strong>
                          {{ email }}
                        </strong>
                      </p>
                    </div>
                    <div style="display: flex">
                      <span
                        style="
                          margin-top: 7.15px;
                          color: #9b0e1c;
                          margin-right: -2.5px;
                          font-size: 20px;
                        "
                        class="material-icons"
                      >
                        location_city
                      </span>
                      <p>
                        Cidade:
                        <strong>
                          {{ city }}
                        </strong>
                      </p>
                    </div>
                    <div>
                      <vs-divider style="margin-bottom: 5px" />
                      <div style="display: flex">
                        <span
                          style="
                            margin-top: 7.15px;
                            color: #9b0e1c;
                            margin-right: -2.5px;
                            font-size: 20px;
                          "
                          class="material-icons"
                        >
                          bookmark
                        </span>
                        <p>
                          <strong>
                            {{ course }}
                          </strong>
                        </p>
                      </div>
                    </div>
                  </vs-col>
                </vs-row>
              </vs-popup>
            </vs-tr>
          </template>
        </vs-table>
        <vs-alert color="danger" icon="new_releases" v-else>
          <b>Sem resultados para serem mostrados</b>
        </vs-alert>
        <vs-popup
          :title="
            this.selectedMailing != null
              ? 'Atendimento - ' + this.selectedMailing.CODATENDIMENTO
              : 'Atendimento'
          "
          :active.sync="discussionScreen"
        >
          <vs-card>
            <vs-tabs alignment="center">
              <vs-tab
                icon="edit"
                :label="
                  history == 'Atendimento sem discussão'
                    ? 'Adicionar Discussão'
                    : 'Atualizar Discussão'
                "
              >
                <vs-row>
                  <vs-col>
                    <vs-textarea
                      v-model="discussionText"
                      height="10rem"
                      :label="
                        'Informe o texto para ' +
                        (history == 'Atendimento sem discussão'
                          ? 'adicionar'
                          : 'atualizar') +
                        ' a discussão do atendimento'
                      "
                    />
                  </vs-col>
                </vs-row>
                <vs-row>
                  <vs-button
                    icon="check_circle"
                    color="#139B0E"
                    style="width: 100%"
                    :disabled="!discussionText"
                    @click="updateDiscussion()"
                  >
                    {{
                      history == "Atendimento sem discussão"
                        ? "Adicionar"
                        : "Atualizar"
                    }}
                  </vs-button>
                </vs-row>
              </vs-tab>
              <vs-tab icon="group" label="Histórico">
                <p v-html="history"></p>
              </vs-tab>
              <vs-tab icon="assessment" label="Tabulação">
                <div>
                  <div style="display: flex">
                    <span
                      style="
                        font-size: 16.5px;
                        color: #9b0e1c;
                        margin-right: 3.5px;
                      "
                      class="material-icons"
                    >
                      feedback
                    </span>
                    <h4>Motivo da Falta de Contato do Cliente</h4>
                  </div>
                  <div v-if="!editLackOfContact" style="display: flex">
                    <vs-input
                      style="margin-top: 8.5px"
                      disabled
                      :placeholder="
                        this.selectedMailing != null
                          ? this.selectedMailing.MOTIVONAOCONTATO
                          : '-'
                      "
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="edit"
                      type="filled"
                      color="danger"
                      @click="lackContact()"
                    />
                  </div>
                  <div v-else style="display: flex">
                    <vs-select
                      style="margin-top: 8.5px"
                      name="motivofaltacontato"
                      autocomplete
                      width="100%"
                      v-model="lackOfContact"
                      placeholder="Selecione um Motivo da Falta de Contato do Cliente"
                    >
                      <vs-select-item
                        :key="index"
                        :value="option"
                        :text="option.DESCRICAO"
                        v-for="(option, index) in notContact"
                      />
                    </vs-select>
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="close"
                      type="filled"
                      @click="editLackOfContact = false"
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="done"
                      :disabled="
                        !lackOfContact ||
                        lackOfContact.DESCRICAO ==
                          this.selectedMailing.MOTIVONAOCONTATO
                      "
                      type="filled"
                      color="#139B0E"
                      @click="
                        modifyLackOfContact(selectedMailing, lackOfContact)
                      "
                    />
                  </div>
                </div>
                <vs-divider />
                <div>
                  <div style="display: flex">
                    <span
                      style="
                        font-size: 16.5px;
                        color: #9b0e1c;
                        margin-right: 3.5px;
                      "
                      class="material-icons"
                    >
                      block
                    </span>
                    <h4>Motivo/ Ação</h4>
                  </div>
                  <div v-if="!editFailureToRegister" style="display: flex">
                    <vs-input
                      style="margin-top: 8.5px"
                      disabled
                      :placeholder="
                        this.selectedMailing != null
                          ? this.selectedMailing.MOTIVONAOINTERESSE
                          : '-'
                      "
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="edit"
                      type="filled"
                      color="danger"
                      @click="failureRegister()"
                    />
                  </div>
                  <div v-else style="display: flex">
                    <vs-select
                      style="margin-top: 8.5px"
                      name="motivonaorealizacao"
                      autocomplete
                      width="100%"
                      v-model="failureToRegister"
                      placeholder="Selecione um Motivo/ Ação"
                    >
                      <vs-select-item
                        :key="index"
                        :value="option"
                        :text="option.DESCRICAO"
                        v-for="(option, index) in notEnrolling"
                      />
                    </vs-select>
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="close"
                      type="filled"
                      @click="editFailureToRegister = false"
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="done"
                      :disabled="
                        !failureToRegister ||
                        failureToRegister.DESCRICAO ==
                          this.selectedMailing.MOTIVONAOINTERESSE
                      "
                      type="filled"
                      color="#139B0E"
                      @click="
                        modifyFailureToRegister(
                          selectedMailing,
                          failureToRegister
                        )
                      "
                    />
                  </div>
                </div>
                <vs-divider />
                <!--<div>
                  <div style="display: flex">
                    <span
                      style="
                        font-size: 16.5px;
                        color: #9b0e1c;
                        margin-right: 4.15px;
                      "
                      class="material-icons"
                    >
                      school
                    </span>
                    <h4>Palestrante</h4>
                  </div>
                  <div v-if="!editSpeaker" style="display: flex">
                    <vs-input
                      style="margin-top: 8.5px"
                      disabled
                      :placeholder="
                        this.selectedMailing != null
                          ? this.selectedMailing.EXTERNO
                          : '-'
                      "
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="edit"
                      type="filled"
                      color="danger"
                      @click="speaker()"
                    />
                  </div>
                  <div v-else style="display: flex">
                    <vs-input
                      style="margin-top: 8.5px"
                      name="palestrante"
                      v-model="speakerNew"
                      placeholder="Digite o Nome do Palestrante"
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="close"
                      type="filled"
                      @click="editSpeaker = false"
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="done"
                      :disabled="
                        !speakerNew ||
                        speakerNew == this.selectedMailing.EXTERNO
                      "
                      type="filled"
                      color="#139B0E"
                      @click="modifySpeaker(selectedMailing, speakerNew)"
                    />
                  </div>
                </div>
                <vs-divider />-->
                <div>
                  <div style="display: flex">
                    <span
                      style="
                        font-size: 16.5px;
                        color: #9b0e1c;
                        margin-right: 3.5px;
                      "
                      class="material-icons"
                    >
                      bookmark
                    </span>
                    <h4>Curso</h4>
                  </div>
                  <div v-if="!editCourse" style="display: flex">
                    <vs-input
                      style="margin-top: 8.5px"
                      disabled
                      :placeholder="
                        this.selectedMailing != null
                          ? this.selectedMailing.CURSOCONVERSAO
                          : '-'
                      "
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="edit"
                      type="filled"
                      color="danger"
                      @click="courseAtt()"
                    />
                  </div>
                  <div v-else style="display: flex">
                    <vs-select
                      style="margin-top: 8.5px"
                      name="curso"
                      autocomplete
                      width="100%"
                      v-model="courseEdit"
                      placeholder="Selecione um Curso"
                    >
                      <vs-select-item
                        :key="index"
                        :value="option"
                        :text="option.DESCRICAO"
                        v-for="(option, index) in courseAttend"
                      />
                    </vs-select>
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="close"
                      type="filled"
                      @click="
                        editCourse = false;
                        otherCourse = null;
                      "
                    />
                    <vs-button
                      style="margin: 3.5px 0 0 5px"
                      icon="done"
                      :disabled="
                        !courseEdit ||
                        courseEdit.DESCRICAO == this.selectedMailing.CURSO ||
                        (courseEdit.DESCRICAO == 'OUTROS' && !otherCourse)
                      "
                      type="filled"
                      color="#139B0E"
                      @click="
                        modifyCourse(selectedMailing, courseEdit, otherCourse)
                      "
                    />
                  </div>
                  <vs-divider />
                  <div
                    v-if="
                      editCourse &&
                      courseEdit &&
                      courseEdit.DESCRICAO == 'OUTROS'
                    "
                    style="display: flex"
                  >
                    <p style="font-size: 0.915em; width: 35%">
                      Digite o curso desejado:
                    </p>
                    <vs-input v-model="otherCourse" />
                  </div>
                </div>
              </vs-tab>
              <vs-tab icon="account_circle" label="Lead">
                <div>
                  <div style="display: flex">
                    <div style="width: 38.5%; margin-left: 5px">
                      <div style="display: flex">
                        <span
                          style="
                            font-size: 16.5px;
                            color: #9b0e1c;
                            margin-right: 3.5px;
                          "
                          class="material-icons"
                        >
                          flag
                        </span>
                        <h4>Estado</h4>
                      </div>
                      <div v-if="!editProspect">
                        <vs-input
                          style="margin-top: 8.5px"
                          disabled
                          :placeholder="
                            this.selectedMailing != null
                              ? this.selectedMailing.ESTADO
                              : '-'
                          "
                        />
                      </div>
                      <div v-else>
                        <vs-select
                          style="margin-top: 8.5px"
                          name="estadoprospect"
                          autocomplete
                          width="100%"
                          v-model="stateProspect"
                          v-on:input="changeProvinces($event)"
                          placeholder="Selecione um Estado"
                        >
                          <vs-select-item
                            v-for="(option, i) in states"
                            :key="i"
                            :value="option.CODIGO"
                            :text="option.CODIGO"
                          />
                        </vs-select>
                      </div>
                    </div>
                    <div style="width: 51.5%">
                      <div style="display: flex">
                        <span
                          style="
                            font-size: 16.5px;
                            color: #9b0e1c;
                            margin-right: 3.5px;
                          "
                          class="material-icons"
                        >
                          location_city
                        </span>
                        <h4>Cidade</h4>
                      </div>
                      <div v-if="!editProspect">
                        <vs-input
                          style="margin-top: 8.5px"
                          disabled
                          :placeholder="
                            this.selectedMailing != null
                              ? this.selectedMailing.CIDADE
                              : '-'
                          "
                        />
                      </div>
                      <div v-else>
                        <vs-select
                          style="margin-top: 8.5px"
                          name="cidadeprospect"
                          autocomplete
                          width="100%"
                          :disabled="!stateProspect"
                          v-model="cityProspect"
                          placeholder="Selecione uma Cidade"
                        >
                          <vs-select-item
                            v-for="(municipio, i) in cities"
                            :key="i"
                            :value="municipio"
                            :text="municipio.title"
                          />
                        </vs-select>
                      </div>
                    </div>
                    <div style="width: 10%" v-if="!editProspect">
                      <vs-button
                        style="margin: 17.5px 0 0 5px"
                        icon="edit"
                        type="filled"
                        color="danger"
                        @click="
                          editProspect = true;
                          cityProspect = null;
                          stateProspect = null;
                        "
                      />
                    </div>
                    <div style="width: 17.5%" v-else>
                      <vs-button
                        style="margin: 18.5px 0 0 5px"
                        icon="close"
                        type="filled"
                        @click="
                          editProspect = false;
                          cityProspect = null;
                          stateProspect = null;
                        "
                      />
                      <vs-button
                        style="margin: 18.5px 0 0 5px"
                        icon="done"
                        :disabled="
                          !cityProspect ||
                          (cityProspect.title == this.selectedMailing.CIDADE &&
                            stateProspect == this.selectedMailing.ESTADO)
                        "
                        type="filled"
                        color="#139B0E"
                        @click="
                          modifyProspect(
                            selectedMailing,
                            cityProspect,
                            stateProspect
                          )
                        "
                      />
                    </div>
                  </div>
                </div>
              </vs-tab>
            </vs-tabs>
          </vs-card>
        </vs-popup>
      </section>
    </div>
  </div>
</template>

<script>
import sortBy from "sort-by";
import Mailing from "../services/mailing";
import moment from "moment";
import {
  updateStepsInformation,
  onlyUpdateDiscussion,
  getLoginDataFromStorage,
} from "../helpers";
export default {
  name: "MyDiary",
  data: () => ({
    descriptionItems: [10, 50, 100],
    diary: [],
    selectedMailing: null,
    discussionScreen: false,
    error: null,
    attendanceId: null,
    discussionText: null,
    editLackOfContact: false,
    editProspect: false,
    cityProspect: null,
    stateProspect: null,
    cities: [],
    states: [],
    notContact: [],
    notEnrolling: [],
    courseAttend: [],
    editFailureToRegister: false,
    editSpeaker: false,
    editCourse: false,
    msgAttendance: false,
    lackOfContact: null,
    otherCourse: null,
    failureToRegister: null,
    speakerNew: null,
    courseEdit: null,
    history: null,
    contactScreen: false,
    searchAtt: false,
    client: null,
    telephone: null,
    email: null,
    city: null,
    course: null,
    sortProperty: "CODATENDIMENTO", // Propriedade inicial para ordenação
    sortOrder: "asc", // Ordem inicial da ordenação
  }),
  created() {
    this.userData = getLoginDataFromStorage();

    const profileSpecial = this.userData.profiles.find(
      (element) =>
        element == "CoordenadorVend" ||
        element == "SupervisorVenda" ||
        element == "DBA"
    );

    if (profileSpecial) {
      this.searchAtt = true;
    } else {
      this.searchAtt = false;
    }
  },
  mounted() {
    this.init();
    this.getStates();
  },
  methods: {
    attendanceSearch(attendance) {
      this.msgAttendance = false;

      this.$vs.loading();
      new Mailing()
        .searchAttendance(attendance)
        .then((res) => {
          this.msgAttendance =
            res.data == "" ? "Atendimento não encontrado" : res.data.MSG;
        })
        .catch((error) => {
          this.msgAttendance = error.response.data.error;
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    sortData(property) {
      if (this.sortProperty === property) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortProperty = property;
        this.sortOrder = "asc";
      }
      this.diary.sort(
        sortBy(this.sortOrder === "asc" ? property : `-${property}`)
      );
    },

    init() {
      this.findBy();
    },

    getStates() {
      new Mailing()
        .getStates()
        .then((res) => {
          this.states = res.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    changeProvinces(state) {
      this.$vs.loading();
      this.cityProspect = null;
      new Mailing()
        .getCities(state)
        .then((res) => {
          let cidades = res.data.map((municipio) => ({
            value: JSON.parse(municipio.value),
            title: municipio.title,
          }));
          this.cities = cidades;
        })
        .catch((error) => {
          console.error("Error trying to fetch cities", error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    showContact(tr) {
      this.contactScreen = true;

      this.client = tr.CLIENTE;
      this.telephone = tr.TELEFONE;
      this.email = tr.EMAIL;
      this.city = tr.CIDADE;
      this.course = tr.CURSO;
    },

    lackContact() {
      this.$vs.loading();

      this.editLackOfContact = true;
      this.lackOfContact = null;

      new Mailing()
        .reasonNotContact()
        .then((res) => {
          this.notContact = res.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    modifyLackOfContact(infoAttendance, param7) {
      this.$vs.loading();

      this.editLackOfContact = false;
      this.lackOfContact = null;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_7: param7.CODIGO,
        PARAMETRO_8: "",
        PARAMETRO_177: "",
        PARAMETRO_189: "",
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Motivo da Falta de Contato editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou o Motivo da Falta de Contato com o Cliente \n" +
              "DE: " +
              infoAttendance.MOTIVONAOCONTATO +
              "\n" +
              "PARA: " +
              param7.DESCRICAO,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.MOTIVONAOCONTATO = param7.DESCRICAO;

          this.getDiscussion(
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    failureRegister() {
      this.$vs.loading();

      this.editFailureToRegister = true;
      this.failureToRegister = null;

      new Mailing()
        .reasonNotEnrolling()
        .then((res) => {
          this.notEnrolling = res.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    speaker() {
      this.$vs.loading();

      this.editSpeaker = true;
      this.speakerNew = null;

      setTimeout(() => {
        this.$vs.loading.close();
      }, 500);
    },

    modifySpeaker(infoAttendance, param225) {
      this.$vs.loading();

      this.editSpeaker = false;
      this.speakerNew = null;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_225: param225,
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Palestrante editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou o Palestrante \n" +
              "DE: " +
              infoAttendance.EXTERNO +
              "\n" +
              "PARA: " +
              param225,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.EXTERNO = param225;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    modifyFailureToRegister(infoAttendance, param8) {
      this.$vs.loading();

      this.editFailureToRegister = false;
      this.failureToRegister = null;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_7: "",
        PARAMETRO_8: param8.CODIGO,
        PARAMETRO_177: "",
        PARAMETRO_189: "",
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Motivo/ Ação editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou o Motivo/ Ação \n" +
              "DE: " +
              infoAttendance.MOTIVONAOINTERESSE +
              "\n" +
              "PARA: " +
              param8.DESCRICAO,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.MOTIVONAOINTERESSE = param8.DESCRICAO;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    courseAtt() {
      this.$vs.loading();

      this.editCourse = true;
      this.courseEdit = null;

      new Mailing()
        .courseAttendance()
        .then((res) => {
          this.courseAttend = res.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    modifyCourse(infoAttendance, course, other) {
      this.$vs.loading();

      this.editCourse = false;
      this.courseEdit = null;
      this.otherCourse = null;

      const payload = {
        CODLOCAL: infoAttendance.CODLOCAL,
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODATENDIMENTO: infoAttendance.CODATENDIMENTO,
        CODCOLIGADARESP: infoAttendance.CODCOLIGADARESP,
        CODATENDENTERESP: infoAttendance.CODATENDENTERESP,
        PARAMETRO_7: "",
        PARAMETRO_8: "",
        PARAMETRO_177: other ? other : course.DESCRICAO,
        PARAMETRO_189: other ? "51" : course.CODIGO,
      };

      new Mailing()
        .updateParamsAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Curso editado com sucesso.",
            color: "success",
            position: "top-center",
          });

          if (infoAttendance.CURSOCONVERSAO == "OUTROS" && other) {
            onlyUpdateDiscussion(
              "Alterou o Curso do Atendimento \n" +
                "DE: " +
                infoAttendance.CURSO +
                "\n" +
                "PARA: " +
                (other ? other : course.DESCRICAO),
              infoAttendance.CODCOLIGADA,
              infoAttendance.CODLOCAL,
              infoAttendance.CODATENDIMENTO
            );
          } else {
            onlyUpdateDiscussion(
              "Alterou o Curso do Atendimento \n" +
                "DE: " +
                infoAttendance.CURSO +
                "\n" +
                "PARA: " +
                (other ? other : course.DESCRICAO) +
                "\n\n" +
                "Alterou o Curso de Conversão do Atendimento \n" +
                "DE: " +
                "(" +
                infoAttendance.CODCURSOCONVERSAO +
                ") " +
                infoAttendance.CURSOCONVERSAO +
                "\n" +
                "PARA: " +
                (other
                  ? "(51) OUTROS"
                  : "(" + course.CODIGO + ") " + course.DESCRICAO),
              infoAttendance.CODCOLIGADA,
              infoAttendance.CODLOCAL,
              infoAttendance.CODATENDIMENTO
            );
          }

          infoAttendance.CURSOCONVERSAO = other ? "OUTROS" : course.DESCRICAO;
          infoAttendance.CURSO = other ? other : course.DESCRICAO;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    modifyProspect(infoAttendance, prospectCity, prospectState) {
      this.$vs.loading();

      this.editProspect = false;
      this.cityProspect = null;
      this.stateProspect = null;

      const payload = {
        CODCOLIGADA: infoAttendance.CODCOLIGADA,
        CODPROSPECT: infoAttendance.CODPROSPECT,
        NOME: infoAttendance.CLIENTE,
        CODORIGEM: infoAttendance.CODORIGEM ? infoAttendance.CODORIGEM : "",
        ESTADO: prospectState,
        CIDADE: prospectCity.value.CODIGO,
      };

      new Mailing()
        .updateProspectAttendance(payload)
        .then(() => {
          this.$vs.notify({
            title: "Sucesso",
            text: "Localidade do Prospect editada com sucesso.",
            color: "success",
            position: "top-center",
          });

          onlyUpdateDiscussion(
            "Alterou a Localidade do Prospect \n" +
              "DE: " +
              (infoAttendance.CIDADE != "-"
                ? infoAttendance.CIDADE + " - " + infoAttendance.ESTADO
                : "-") +
              "\n" +
              "PARA: " +
              prospectCity.title +
              " - " +
              prospectState,
            infoAttendance.CODCOLIGADA,
            infoAttendance.CODLOCAL,
            infoAttendance.CODATENDIMENTO
          );

          infoAttendance.CIDADE = prospectCity.title;
          infoAttendance.ESTADO = prospectState;
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    getDiscussion(CODCOLIGADA, CODLOCAL, CODATENDIMENTO) {
      new Mailing()
        .getDiscussion(CODCOLIGADA, CODLOCAL, CODATENDIMENTO)
        .then(({ data }) => {
          this.history =
            data.TEXTODISCUSSAO == null
              ? "Atendimento Sem Discussão"
              : data.TEXTODISCUSSAO.replaceAll("\n", "<br />");
          this.$vs.loading.close();
        });
    },

    async showDiscussionScreen(data) {
      this.editLackOfContact = false;
      this.editFailureToRegister = false;
      this.editCourse = false;
      this.editProspect = false;
      this.selectedMailing = data;
      this.$vs.loading();
      this.getDiscussion(data.CODCOLIGADA, data.CODLOCAL, data.CODATENDIMENTO);
      this.discussionScreen = true;
      this.discussionText = null;
    },

    async updateDiscussion() {
      this.$vs.loading();
      await onlyUpdateDiscussion(
        this.discussionText,
        this.selectedMailing.CODCOLIGADA,
        this.selectedMailing.CODLOCAL,
        this.selectedMailing.CODATENDIMENTO
      ).finally(() => {
        this.discussionScreen = false;
        this.$vs.loading.close();
      });

      const payload = {
        CODLOCAL: this.selectedMailing.CODLOCAL,
        CODCOLIGADA: this.selectedMailing.CODCOLIGADA,
        CODATENDIMENTO: this.selectedMailing.CODATENDIMENTO,
        CODCOLIGADARESP: this.selectedMailing.CODCOLIGADARESP,
        CODATENDENTERESP: this.selectedMailing.CODATENDENTERESP,
      };

      new Mailing()
        .updateParamsDiscussion(payload)
        .then((data) => {
          console.log(data);
        })
        .catch((response) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },

    findBy() {
      this.$vs.loading({
        color: "danger",
      });
      new Mailing()
        .getMy()
        .then((response) => {
          let diary = Array.isArray(response.data)
            ? response.data
            : [response.data];
          let diaryMap = diary.map((a) => {
            a.MORE = false;
            return a;
          });
          this.diary = diaryMap;
        })
        .catch(({ response }) => {
          if (response && response.data) {
            this.error = response.data.error;
          }
        })
        .finally(() => {
          this.$vs.loading.close();
          console.log(this.error);
        });
    },

    startSimulation(mailingData) {
      updateStepsInformation({
        codAtendimento: mailingData.CODATENDIMENTO,
        codColigada: mailingData.CODCOLIGADA,
        codLocal: mailingData.CODLOCAL,
      });
      onlyUpdateDiscussion(
        "Simulação de Matrícula Iniciada",
        mailingData.CODCOLIGADA,
        mailingData.CODLOCAL,
        mailingData.CODATENDIMENTO
      );
      this.$router.push("/courses");
    },
  },
  filters: {
    moment: function (date) {
      moment.locale("pt-br");
      return moment(date).format("DD/MM/YYYY");
    },
  },
};
</script>

<style>
.vs-input--input:disabled,
.vs-input--input:disabled + .vs-input--placeholder {
  opacity: 1;
  cursor: default;
  color: black;
  pointer-events: none;
}
.vs-table-text {
  padding: 10px;
  border-bottom: 1px solid var(--secundary);
}
a {
  color: var(--dark);
}
</style>
